/**
 * admin模块接口列表
 */
import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const admin = {
  // POST/admin/distribute 管理员分配------ygt
  distribute(params) {
    return axios.post(`${base.baseURL}admin/distribute`, params);
  },
  //POST/admin/page 分页查询管理员账户信息(关键字(账户，姓名，手机号)模糊查询)------ygt 
  getadminpage(param) {
    return axios.post(`${base.baseURL}admin/page`, param);
  },
  //POST /admin/personal 首页当前登录账户个人资料------ygt
  personalAdm() {
    return axios.post(`${base.baseURL}admin/personal`);
  },
  // GET/tenant/query PC----根据tenantId查询信息-----ygt
  tenantQuery() {
    return axios.get(`${base.baseURL}tenant/query`);
  },
  //GET/admin/randomPwd 生成随机密码------ygt
  randomPwd() {
    return axios.get(`${base.baseURL}admin/randomPwd`);
  },
  //DELETE/admin/remove/{id} 删除管理员账户------ygt
  removeuser(id) {
    return axios.delete(`${base.baseURL}admin/remove/${id}`);
  },
  //POST/admin/resetPwd 重置管理员账户密码------ygt
  resetPwd(params) {
    return axios.post(`${base.baseURL}admin/resetPwd`, params);
  },
  //POST/admin/roleIdPage 查询角色下的管理员信息------ygt
  // roleIdPage(pageNo, pageSize, roleId) {
  //   return axios.post(`${base.baseURL}admin/roleIdPage`, {
  //     "pageNo": pageNo,
  //     "pageSize": pageSize,
  //     "roleId": roleId

  //   });
  // },
  //POST   /admin/rolePage  分页查询角色列表(供选择)
  rolePage(params) {
    return axios.post(`${base.baseURL}admin/rolePage`, params);
  },
  //POST/admin/save 添加/修改管理员账户------ygt
  saveadmin(param) {
    return axios.post(`${base.baseURL}admin/save`, param);
  },
  //POST/admin/status/{id} 启动或停用管理员账户------ygt
  statusadmin(status, id) {
    return axios.post(`${base.baseURL}admin/status/${id}?status=${status}`);
  },
  //POST/admin/unRolePage 查询管理员账户信息(未分配角色的)------ygt
  unRolePage(params) {
    return axios.post(`${base.baseURL}admin/unRolePage`, params);
  },
  //POST/admin/user/{id} 查询管理员账户------ygt
  getadminuser(id) {
    return axios.post(`${base.baseURL}admin/user/${id}`);
  },
  // POST/index/tenantInfo 租户logo及公司名称--ygt
  tenantInfo() {
    return axios.post(`${base.baseURL}index/tenantInfo`);
  }
}
export default admin;



// WEBPACK FOOTER //
// ./src/network/admin.js